<template>
  <div id="app">
  	<!-- <router-view/> -->
    <keep-alive><router-view/></keep-alive>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style>
	.el-table td {
    padding: 5px 1px;
    /*color: #000;*/
  }
  .el-table th {
  	padding: 12px 1px;
  	/*color: #000;*/
  }
  .el-table .cell {
    padding: 0 1px;
  }
  .el-table--border, .el-table--group {
    /*border-color: #000;*/
  }
  .el-table--border:after, .el-table--group:after, .el-table:before {
    /*background-color: #000;*/
  }
  .el-table td, .el-table--border th, .el-table th.is-leaf {
    /*border-bottom-color: #000 !important;*/
  }
  .el-table--border td, .el-table--border th {
    /*border-right-color: #000 !important;*/
  }
</style>



// WEBPACK FOOTER //
// src/App.vue